import { saveQuotesAndArticles, updateQuotesAndArticles, getQuotes } from "../api";
import { Toast } from "src/components";
import { getAssetUrl, isArticleEmpty } from "../utils";

export const useSaveQuoteAndArticle = () => {

    const sanitizePayload = (formData, isUpdate = false) => {
        const payload = { ...formData };
        delete payload.objectImage;

        if (isUpdate) {
            [
                "uuid", "pool",
                "publishDate", "quoteCategories",
                "deleted_at", "article.uuid", "article.deleted_at"
            ].forEach(key => delete payload[key]);

            Object.assign(payload, {
                dayOfWeek: "",
                specialDate: "",
                quoteTypes: null,
                isFreeContent: false,
                quotePool: 3,
            });

            if (!isArticleEmpty(payload.article)) {
                payload.article.active = true;
            }
        }

        if (isArticleEmpty(payload.article)) {
            payload.article = null;
            payload.isFreeContent = false;
        }

        return payload;
    };

    const refreshQuotes = async (user, companyUuid, setQuotes, uuid = null) => {
        const { quotes: fetchedQuotes } = await getQuotes(user, companyUuid);
        const filteredQuotes = fetchedQuotes.filter(item => !item.deleted_at);

        // Only apply to the currently edited quote to ensure the updated image is displayed
        const updatedQuotes = filteredQuotes.map(item => {
            if (uuid && item.uuid === uuid) {
                return {
                    ...item,
                    imageUrl: getAssetUrl(item.imageUrl),
                    article: item.article && item.article.imageUrl
                        ? {
                            ...item.article,
                            imageUrl: getAssetUrl(item.article.imageUrl)
                        }
                        : item.article
                };
            }
            return item;
        });
        setQuotes(updatedQuotes);
    };

    const saveData = async (params, manageQuotes, formData) => {
        const payload = sanitizePayload(formData);
        const response = await saveQuotesAndArticles(payload);

        if (response) {
            await refreshQuotes(params.user, params.companyUuid, params.setQuotes);
            manageQuotes.createQuotes(false);
            Toast.success("Quote has been successfully added.");
        }

        return response;
    };

    const updateData = async (params, manageQuotes, uuid, formData) => {
        const payload = sanitizePayload(formData, true);
        const response = await updateQuotesAndArticles(uuid, payload);

        if (response) {
            await refreshQuotes(params.user, params.companyUuid, params.setQuotes, response?.updatedQuote.uuid);
            manageQuotes.createQuotes(false);
            Toast.success("Quote has been successfully updated.");
        }

        return response;
    };

    return { saveData, updateData, isArticleEmpty };
};
